import type { Theme } from '@mui/material';

export const getBarColor = (
  theme: Theme,
  index: number,
  customColor?: string,
) =>
  customColor ||
  [
    theme.colors.stackedVeryNegative,
    theme.colors.stackedNegative,
    theme.colors.stackedNeutral,
    theme.colors.stackedPositive,
    theme.colors.stackedVeryPositive,
  ][index];

export const styles = {
  stackedBarWidget: {},

  stackedBarLegend: {
    display: 'flex',
    flexGrow: 1,
  },

  legendLabel:
    (index: number, customColor: string, pinsLength: number) =>
    (theme: Theme) => ({
      width: `calc(${pinsLength ? 100 / pinsLength : 20}%)`,
      borderBottom: '4px solid',
      fontWeight: 'normal',
      display: 'flex',
      justifyContent: 'center',
      textAlign: 'center',
      alignItems: 'flex-end',
      borderColor: getBarColor(theme, index, customColor),
    }),

  number: (theme: Theme) => ({
    [theme.breakpoints.down('lg')]: {
      marginTop: -1,
    },
  }),

  stackedBar: {
    display: 'flex',
    flexGrow: 1,
  },

  stackElement: (index: number, customColor?: string) => (theme: Theme) => ({
    color: '#fff',
    textAlign: 'center',
    lineHeight: '28px',
    fontSize: 14,
    flexGrow: 1,
    flexBasis: 0,
    backgroundColor: getBarColor(theme, index, customColor),
  }),
};
